import request from "../utils/request"

export function fetchPointsExchanges(params = {}) {
  return request({
    url: "/admin/points/exchanges",
    method: "get",
    params
  })
}

export function shipPointsExchange(id, data = {}) {
  return request({
    url: `/admin/points/exchanges/${id}/ship`,
    method: "post",
    data
  })
}
